import React from 'react';
import Lottie from 'react-lottie';
import GreenBlinkingLottie from './GreenBlinkingLottie.json';

const GreenBlinkingDotLottie = ({ width = 20, height = 20 }) => {
    const lottieOptions = {
        loop: true,
        autoplay: true,
        animationData: GreenBlinkingLottie,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <Lottie
            options={lottieOptions}
            height={height}
            width={width}
        />
    );
};

export default GreenBlinkingDotLottie;
